import { Link, NavLink } from "react-router-dom";
import { NavBar } from "./NavBar";
import { useState, useEffect } from "react";
import { useAppContext } from "../../Context/Store";

export const Header = ({ onSendData }) => {
  const { isError, isLoading, ContactData } = useAppContext();
  const { properties } = ContactData;

  const [isNavOpen, setIsNavOpen] = useState(false);

  // Function to handle input change
  const handleChange = () => {
    onSendData(true); 
  };

  const handleNav = (data) => {
    setIsNavOpen(data);
    //console.log("Navigation Value", data);
  };

  useEffect(() => {
    //sendBodyClass(false);
    // Assuming `sendBodyClass` is meant to add or remove classes to `body`
    if (isNavOpen) {
        document.querySelector("body").classList.add("nav-open");  
        setTimeout(function(){   
            document.querySelector("body").classList.add("nv");
        }, 50);
    } else {
        setTimeout(function(){   
            document.querySelector("body").classList.remove("nav-open"); 
        }, 200); 
        document.querySelector("body").classList.remove("nv");
    } 
    // return () => {
    //     setTimeout(function(){   
    //         document.querySelector("body").classList.remove("nav-open"); 
    //     }, 200); 
    //     document.querySelector("body").classList.remove("nv");
    // };
  }, [isNavOpen]);

  return (
    <header>
      <div id="header">
        <NavLink
          className="logo"
          to="/"
          title={properties?.copyRightText || "Promovara"}
        >
          {properties?.copyRightText || "Promovara"}
        </NavLink>
        <a className="menu mobile ir" onClick={() => handleNav(true)}>
          Menu
        </a>
        <nav>
          <NavBar handleNavVal={handleNav} onSendDataVal={onSendData} />
        </nav>
        <div className="btn-find-home web">
          <button className="btn enq-b" onClick={handleChange}>
            Enquire now
          </button>
          <NavLink className="btn sbc" to="our-collection">
            <span className="sbc-icon">
              <b className="circle"></b>
              <b className="rectangle"></b>
            </span>
            Search by category
          </NavLink>
        </div>
      </div>
    </header>
  );
};
